export enum ApplicationStatusRulesValidationActionType {
  GetStatusesRulesValidationResults = 'applicationStatusesRules/getStatusesRulesValidationResults',
  GetStatusesRulesValidationResultsSuccess = 'applicationStatusesRules/getStatusesRulesValidationResultsSuccess',
  GetStatusesRulesValidationResultsFailure = 'applicationStatusesRules/getStatusesRulesValidationResultsFailure',
  ResetStatusesRulesValidationResults = 'applicationStatusesRules/resetStatusesRulesValidationResults',
}
